// extracted by mini-css-extract-plugin
export default {"page":"About_page__Sz2qy","grid":"About_grid__b009s","media":"About_media__qAWua","copy":"About_copy__TXfDm","contact":"About_contact__HLpqG"};